export default function getStripeProductMinQuantity(stripeProduct, seatsQty) {
  seatsQty ||= 1
  // NOTE: `stripeProduct.min_quantity` may be null.
  return stripeProduct.min_quantity
    ? Math.max(seatsQty, stripeProduct.min_quantity)
    : seatsQty
}
